import React, { useState, useEffect } from 'react';

export const VerificationCodeInputField = ({ length = 6, onChange }) => {
  const [verificationCode, setVerificationCode] = useState(new Array(length).fill(''));

  useEffect(() => {
    onChange(verificationCode.join('')); // Inform the parent component when the code changes
  }, [verificationCode, onChange]);

  const handleChange = (index, value) => {
    if (isNaN(value) || value.length > 1) return;

    const newCode = [...verificationCode];
    newCode[index] = value;
    setVerificationCode(newCode);
    
    if (value && index < length - 1) {
      document.getElementById(`verification-input-${index + 1}`).focus(); // Auto-focus next input
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && verificationCode[index] === '') {
      // Focus previous input when backspace is pressed on an empty field
      if (index > 0) {
        document.getElementById(`verification-input-${index - 1}`).focus();
      }
    }
  };

  const handlePaste = (e) => {
    const pastedCode = e.clipboardData.getData('Text').split('').slice(0, length);
    const newCode = new Array(length).fill('');
    
    pastedCode.forEach((digit, index) => {
      if (index < length) newCode[index] = digit;
    });
    setVerificationCode(newCode);
  };

  return (
    <div className="flex flex-row w-full justify-start space-x-2 mt-4">
      {verificationCode.map((digit, index) => (
        <input
          key={index}
          id={`verification-input-${index}`}
          type="text"
          maxLength="1"
          value={digit}
          onChange={(e) => handleChange(index, e.target.value)}
          onPaste={handlePaste}
          onKeyDown={(e) => handleKeyDown(e, index)} // Handle key down for backspace
          className="w-14 h-14 text-center text-lg border rounded-md focus:ring-2 focus:ring-blue-500"
          autoFocus={index === 0}
        />
      ))}
    </div>
  );
};
